/** Effects supplied by the app hook; the ordering is the logout contract. */
export type LogoutEffects = {
  clearPushTokens: () => Promise<unknown>;
  endPlayback: () => void;
  pausePlayback: () => Promise<unknown>;
  resetPlayback: () => void;
  flushPlays: () => Promise<unknown>;
  recordSignOut: () => Promise<unknown>;
  signOut: () => Promise<unknown>;
  endSession: () => Promise<unknown>;
  restart: () => void;
  afterLogout: () => Promise<void>;
  report: (error: unknown, operation: string) => void;
};

export const createLogout = (effects: LogoutEffects) => async () => {
  const bestEffort = async (operation: string, effect: () => unknown) => {
    try {
      await effect();
    } catch (error) {
      try {
        effects.report(error, operation);
      } catch {
        // Even telemetry failure must not strand the user signed in.
      }
    }
  };
  await bestEffort("clear-push-tokens", effects.clearPushTokens);
  effects.endPlayback();
  await effects.pausePlayback();
  effects.resetPlayback();
  await effects.flushPlays().catch(() => {});
  // Start authentication while credentials are present, but never wait for
  // token acquisition, the network or response parsing before signing out.
  bestEffort("record-sign-out", effects.recordSignOut).catch(() => {});
  await bestEffort("sign-out", effects.signOut);
  await bestEffort("end-session", effects.endSession);
  await bestEffort("restart-landing", effects.restart);
  await effects.afterLogout();
};
